import React from 'react';

import UnregisteredLayout from 'modules/Unregistered/components/UnregisteredLayout';

import { Styled } from './ErrorPages.styled';

export default function ErrorPage() {
	return (
		<UnregisteredLayout>
			<Styled.Root id='error-page'>
				<Styled.ImageBox>
					<img src='/images/404.png' alt='Not found page' />
				</Styled.ImageBox>

				<Styled.BoxWrapper>
					<h3>Ooops!</h3>
					<h2>Page not found</h2>
					<p>Please check the spelling of the URL</p>
				</Styled.BoxWrapper>
			</Styled.Root>
		</UnregisteredLayout>
	);
}
